import { Injectable } from '@angular/core';
import { DigitalAssetsService } from 'gung-standard';


@Injectable({
  providedIn: 'root'
})
export class TyloDigitalAssetsService extends DigitalAssetsService{

  public useLinks = true;
}
